import React, { useEffect, useState,useContext,useRef } from "react";

import {
  SimpleGrid,
  
  useToast,
  Button,
  Select,
  TableContainer,
  Table,
  Thead,
  Tr,
  Th,
  Wrap,
  WrapItem
} from "@chakra-ui/react";
import EventCard from "./EventsCard/EventCard";
import { BsSearch } from "react-icons/bs";
import { IconButton, VStack, Box } from "@chakra-ui/react";
import axios from "axios";

import AdminLogin from "../AdminNav/Login";
import { MyContext } from "../../MyProvider";

import { FilterTabs, Ledger, PageHeader, Pagination, SearchField, matchesSearch } from "../../components/ui";
import { API_URL } from "../../Apis/config";

function Events() {
  // const { id } = useParams();
  const{eventData,eventApi,assigneeData,userApi}=useContext(MyContext);

  const [events, setEvents] = useState([]);

  const [filter,setFilter]=useState("Pending");//colored filters on top of ui
  const [counts, setCounts] = useState({
    total: 0,
    completed: 0,
    pending: 0,
    paid: 0,
    unpaid: 0,
    scheduled:0,
    latest:0,
  });//count of colored filters on top of ui

  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [eventsPerPage] = useState(8);
  // const [update, setUpdate] = useState(false);
  // const [payment, setPayment] = useState("");
  // const [totalAppointment, setTotalAppointment] = useState(0);
  // const [pendingAppointment, setPandingAppointment] = useState(0);
  // const [completedAppointment, setCompletedAppointment] = useState(0);
  const searchOption=useRef('name');//search filter
  
  
  const toast = useToast();
  useEffect(() => {
    
    const filEvents=eventData.filter((ele) => ele.eventName != "Kashiyatra");

    const updatedCounts = {
      total: filEvents.length,
      completed: filEvents.filter((ele) => ele.eventStatus === "Completed").length,
      pending: filEvents.filter((ele) => ele.eventStatus === "Pending").length,
      paid: filEvents.filter((ele) => ele.paymentStatus === true).length,
      unpaid: filEvents.filter((ele) => ele.paymentStatus === false).length,
      scheduled:filEvents.filter((ele) => ele.eventDate == today).length,
      latest:filEvents.filter((ele) => ele.bookingDate == today).length
    };
    setCounts(updatedCounts);


  }, [eventData]);
  useEffect(() => {

    const filEvent=eventData.filter((ele) => ele.eventName != "Kashiyatra");

    switch (filter) {
      case "Completed":
        setEvents(filEvent.filter((ele) => ele.eventStatus === "Completed"));
        break;
      case "Pending":
        setEvents(filEvent.filter((ele) => ele.eventStatus === "Pending").sort((a, b) => {
          const [dayA, monthA, yearA] = a.eventDate.split("/");
          const [dayB, monthB, yearB] = b.eventDate.split("/");
          const dateA = new Date(`${yearA}-${monthA}-${dayA}`);
          const dateB = new Date(`${yearB}-${monthB}-${dayB}`);
          return dateA - dateB;
        }));
        break;
      case "Paid":
        setEvents(filEvent.filter((ele) => ele.paymentStatus === true));
        break;
      case "Unpaid":
        setEvents(filEvent.filter((ele) => ele.paymentStatus === false));
        break;
      case "Scheduled":
        setEvents(filEvent.filter((ele) => ele.eventDate==today));
        break;
      case "Latest":
        setEvents(filEvent.filter((ele) => ele.bookingDate == today));
        break;    
      default:
        setEvents([...filEvent]);
        break;
    }



  }, [filter,eventData]);

  useEffect(()=>{
    if(currentPage!=1){setCurrentPage(1)};
  },[filter]);
  
useEffect(()=>{
  
const filevens=eventData.filter((ele) => ele.eventName != "Kashiyatra");

if(filter!="Event"){setFilter("Event")};
if(currentPage!=1){setCurrentPage(1)};
if(search==""){setEvents([...filevens])}
else if(search.length>2){setEvents(filevens.filter((el)=>matchesSearch(el,searchOption.current,search)))}
},[search]);



const today=new Date().toLocaleDateString("en-GB");


   // Get current events based on pagination
  const indexOfLastEvent = currentPage * eventsPerPage;
  const indexOfFirstEvent = indexOfLastEvent - eventsPerPage;
  const currentEvents = events.slice(indexOfFirstEvent, indexOfLastEvent);
  // console.log(currentEvents.length);
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const goToPreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1);
    }
  };
  const goToNextPage = () => {
    if (currentPage < Math.ceil(events.length / eventsPerPage)) {
      setCurrentPage((prevPage) => prevPage + 1);
    }
  };

  const handleFilterChange = (newFilter) => {
    setFilter(newFilter);
  };

  const getHeaderStyle = (name) => ({
    cursor: "pointer",
    backgroundColor: filter === name ? "yellow" : "transparent",
    color: filter === name ? "black" : "white"
    
  });

  const updateEvent=async()=>{

    await eventApi();
    await userApi();
  };


  const handleSubmitEvent = (formData, id) => {
    axios
      .patch(`${API_URL}/event/${id}`, formData)
      .then((res) => {
        updateEvent();
        toast({
          title: "Event Updated",
          description: "Event has been updated successfully.",
          status: "success",
          duration: 5000,
          isClosable: true,
        });
      })
      .catch((err) => {
        toast({
          title: "Error",
          description:"Error occured while updating event",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      });
  };

  const onDeleteConfirmEvent = (id) => {
    axios
      .delete(`${API_URL}/event/${id}`)
      .then((res) => {
        updateEvent();
        toast({
          title: "Event Deleted",
          description: "Event has been deleted successfully",
          status: "success",
          duration: 5000,
          isClosable: true,
        });

        // Perform any necessary actions after successful deletion
      })
      .catch((err) => {
        toast({
          title: "Error",
          description:"Error occured while deleting event",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      });
  };




  const token = localStorage.getItem("AdminToken");
  if (!token) {
    return <AdminLogin />;
  }
  



  return (
    <>
      <PageHeader title="Events" subtitle="Poojas and services booked at home or at the venue">
        <SearchField
          options={[{ value: "name", label: "Name" }, { value: "phone", label: "Mobile" }, { value: "eventName", label: "Event name" }, { value: "bookingDate", label: "Submission" }, { value: "eventDate", label: "Scheduled" }]}
          onFieldChange={(event)=>{searchOption.current=event.target.value;}}
          onSearch={(e) => setSearch(e.target.value)}
        />
      </PageHeader>
      <FilterTabs
        active={filter}
        onChange={handleFilterChange}
        tabs={[
          { key: "Pending", label: "Pending", count: counts.pending },
          { key: "Completed", label: "Completed", count: counts.completed },
          { key: "Paid", label: "Paid", count: counts.paid },
          { key: "Unpaid", label: "Unpaid", count: counts.unpaid },
          { key: "Scheduled", label: "Today", count: counts.scheduled },
          { key: "Latest", label: "Booked today", count: counts.latest },
          { key: "Event", label: "All", count: counts.total },
        ]}
      />
      <Ledger
        columns="minmax(0,1.4fr) minmax(0,1.2fr) minmax(0,1fr) 110px 360px"
        heads={["Name", "Event", "Scheduled", "Status", ""]}
        isEmpty={events.length === 0}
        emptyText="No events here. Try another filter or clear the search."
      >
        {currentEvents.length > 0 &&
          currentEvents.map((evt) => (
            <EventCard
              key={evt._id}
              event={evt}
              Update={handleSubmitEvent}
              Delete={onDeleteConfirmEvent}
              eassignees={assigneeData}
              upEvent={updateEvent}
            />
          ))}
      </Ledger>
      <Pagination
        currentPage={currentPage}
        pageCount={Math.ceil(events.length / eventsPerPage)}
        onPrevious={goToPreviousPage}
        onNext={goToNextPage}
        onPage={paginate}
      />
    </>
  );
}

export default Events;
